var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenudots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17C13.6046 17 14.5 17.8954 14.5 19C14.5 20.1046 13.6046 21 12.5 21C11.3954 21 10.5 20.1046 10.5 19C10.5 17.8954 11.3954 17 12.5 17Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C13.6046 10 14.5 10.8954 14.5 12C14.5 13.1046 13.6046 14 12.5 14C11.3954 14 10.5 13.1046 10.5 12C10.5 10.8954 11.3954 10 12.5 10Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C13.6046 3 14.5 3.89543 14.5 5C14.5 6.10457 13.6046 7 12.5 7C11.3954 7 10.5 6.10457 10.5 5C10.5 3.89543 11.3954 3 12.5 3Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenudots);
export default __webpack_public_path__ + "static/media/menudots.42720981cb77f05bb4e3e11d1f85b420.svg";
export { ForwardRef as ReactComponent };